import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PlausibleAnalytics = () => {
  const location = useLocation();
  
  // Don't load analytics on admin pages
  const isAdminPage = location.pathname.startsWith("/admin");
  
  useEffect(() => {
    if (isAdminPage) return;
    
    // Check if scripts are already loaded
    if (document.getElementById("plausible-script")) return;
    
    // Add the main Plausible script
    const mainScript = document.createElement("script");
    mainScript.id = "plausible-script";
    mainScript.async = true;
    mainScript.src = "https://p.softmedia.cz/js/pa--yRZ--sEVqi2Mf10PQR8P.js";
    document.head.appendChild(mainScript);
    
    // Add the initialization script
    const initScript = document.createElement("script");
    initScript.id = "plausible-init";
    initScript.textContent = `
      window.plausible=window.plausible||function(){(plausible.q=plausible.q||[]).push(arguments)},plausible.init=plausible.init||function(i){plausible.o=i||{}};
      plausible.init()
    `;
    document.head.appendChild(initScript);
  }, [isAdminPage]);
  
  return null;
};

export default PlausibleAnalytics;
